import { endPoints } from 'api/';
import { UPDATE_ITEM_QUANTITY } from 'actions/types';

/**
 * @description Updates inventory item attributes or conditions quantity.
 * @param {{}} payload
 */
export function updateQuantity(payload) {
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: UPDATE_ITEM_QUANTITY,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        const { quantity } = payload;
        const result = await apiClient(endPoints.UPDATE_ITEM_QUANTITY, payload);
        const { data } = result;
        const { response } = data;
        const { updatedValues } = response;
        return {
          ...result,
          data: {
            ...data,
            response: {
              ...response,
              updatedValues: { ...updatedValues, quantity },
            },
          },
        };
      },
    };
    dispatch(action);
  };
}
